import { useEffect, useState, useCallback } from "react";
import { Button, Card, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import {
  getPermissions,
  getRoles,
  setRole,
  updateRole,
} from "../../../api/rolesApi";
import { useAuth } from "../../context/AuthContext";
import Layout from "../../layout/Layout";

function RoleManagementPage() {
  const { token } = useAuth();

  const [roles, setRoles] = useState([]);
  const [allPermissions, setAllPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [editingRole, setEditingRole] = useState(null);
  const [newRole, setNewRole] = useState({ name: "", permissions: [] });
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingPerm, setPendingPerm] = useState(null);
  const [showSaveConfirm, setShowSaveConfirm] = useState(false);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const roleRes = await getRoles(token);
      const permRes = await getPermissions(token);
      setRoles(roleRes.data.data || []);
      setAllPermissions(permRes.data.data || []);
    } catch (err) {
      console.error("Rol/Permission yüklenemedi:", err);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleOpenModal = (role = null) => {
    if (role) {
      // normalize et: sadece "name" değerlerini al
      const normalizedPermissions = role.permissions.map((p) =>
        typeof p === "string"
          ? { name: p, description: "" }
          : { name: p.name, description: p.description }
      );
      console.log(normalizedPermissions, "12121221");

      setEditingRole(role);
      setNewRole({
        _id: role._id,
        name: role.name,
        permissions: normalizedPermissions,
      });
    } else {
      setEditingRole(null);
      setNewRole({ name: "", permissions: [] });
    }

    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingRole(null);
    setNewRole({ name: "", permissions: [] });
  };
  const handleSaveRole = async () => {
    console.log(newRole, "1111111");
    const payload = {
      updatedId: editingRole?._id,
      name: newRole.name,
      permissions: newRole.permissions,
    };

    if (editingRole) {
      await updateRole(payload, token);
    } else {
      await setRole(payload, token);
    }
  };

  const togglePermission = (permName, permDesc, group, action) => {
    // sadece ekleme (EVET) sırasında confirm göster
    if (group === "admin" && action === "add") {
      setPendingPerm({ permName, permDesc });
      setShowConfirm(true);
      return;
    }

    applyPermission(permName, permDesc, action);
  };

  const applyPermission = (permName, permDesc, action) => {
    setNewRole((prev) => {
      if (action === "remove") {
        return {
          ...prev,
          permissions: prev.permissions.filter((p) => p.name !== permName),
        };
      } else {
        return {
          ...prev,
          permissions: [
            ...prev.permissions,
            { name: permName, description: permDesc },
          ],
        };
      }
    });
  };

  const handleConfirmYes = () => {
    if (pendingPerm) {
      applyPermission(pendingPerm.permName, pendingPerm.permDesc);
    }
    setShowConfirm(false);
    setPendingPerm(null);
  };

  const handleConfirmNo = () => {
    setShowConfirm(false);
    setPendingPerm(null);
  };

  if (loading) {
    return (
      <Layout>
        <div className="d-flex justify-content-center align-items-center py-5">
          <Spinner animation="border" variant="primary" />
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold">Rol Yönetimi</h2>
        <Button variant="primary" onClick={() => handleOpenModal()}>
          + Yeni Rol
        </Button>
      </div>

      <Row xs={1} md={3} className="g-4">
        {roles.length > 0 ? (
          roles.map((role) => (
            <Col key={role._id}>
              <Card
                className="shadow-sm border rounded-3 h-100"
                style={{ minHeight: "100px" }}
              >
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-center gap-2">
                      <div
                        className="rounded d-flex align-items-center justify-content-center"
                        style={{
                          width: 60,
                          height: 60,
                          backgroundColor: "#0d6efd",
                        }}
                      >
                        <i className="bi bi-diagram-3 text-white fs-5"></i>
                      </div>
                      <div>
                        <h5 className="fw-bold m-0">
                          {role.name.toUpperCase()}
                        </h5>
                        <span className="badge bg-secondary">{role.group}</span>
                      </div>
                    </div>
                  </div>

                  <Button
                    variant="outline-secondary"
                    className="w-100 py-2 fs-5"
                    onClick={() => handleOpenModal(role)}
                  >
                    <i className="bi bi-person-gear me-2 fs-4"></i>
                    Düzenle
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))
        ) : (
          <p className="text-muted">Rol bulunamadı</p>
        )}
      </Row>

      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {editingRole ? "Rolü Düzenle" : "Yeni Rol Oluştur"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>İsim</Form.Label>
              <Form.Control
                type="text"
                value={newRole.name}
                onChange={(e) =>
                  setNewRole({ ...newRole, name: e.target.value })
                }
              />
            </Form.Group>

            {/* Yetkiler gruplara göre */}
            {Object.entries(
              allPermissions.reduce((acc, perm) => {
                if (!acc[perm.group]) acc[perm.group] = [];
                acc[perm.group].push(perm);
                return acc;
              }, {})
            ).map(([group, perms]) => (
              <div key={group} className="mb-3">
                <h6 className="fw-bold text-primary border-bottom pb-1">
                  {group.toUpperCase()}
                </h6>
                {perms.map((perm) => {
                  const isChecked = newRole.permissions.some(
                    (p) => p.name === perm.name
                  );
                  return (
                    <div
                      key={perm.name}
                      className="d-flex justify-content-between align-items-center py-2 border-bottom"
                    >
                      <div>
                        <div className="fw-semibold">{perm.description}</div>
                        <div className="text-muted small">{perm.name}</div>
                      </div>
                      <div className="d-flex gap-2">
                        <Button
                          size="sm"
                          className={`perm-btn-evet ${
                            isChecked ? "active" : ""
                          }`}
                          onClick={() => {
                            if (!isChecked)
                              togglePermission(
                                perm.name,
                                perm.description,
                                perm.group,
                                "add"
                              );
                          }}
                        >
                          ✓ EVET
                        </Button>
                        <Button
                          size="sm"
                          className={`perm-btn-hayir ${
                            !isChecked ? "active" : ""
                          }`}
                          onClick={() => {
                            if (isChecked)
                              togglePermission(
                                perm.name,
                                perm.description,
                                perm.group,
                                "remove"
                              );
                          }}
                        >
                          HAYIR
                        </Button>
                      </div>
                    </div>
                  );
                })}
              </div>
            ))}
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Çık
          </Button>
          <Button variant="primary" onClick={() => setShowSaveConfirm(true)}>
            Kaydet
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showSaveConfirm}
        onHide={() => setShowSaveConfirm(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Rol Kaydı Onayı</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Bu rolü {editingRole ? "güncellemek" : "oluşturmak"} üzeresiniz.{" "}
          <br />
          <span className="text-muted small">
            Yaptığınız değişiklikler sistemde kalıcı olarak uygulanacaktır.
          </span>
          <br />
          Devam etmek istediğinize emin misiniz?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowSaveConfirm(false)}>
            Vazgeç
          </Button>
          <Button
            variant="primary"
            onClick={async () => {
              try {
                await handleSaveRole(); // rolü ekle/güncelle
                await fetchData(); // tekrar rolleri çek
                setShowSaveConfirm(false);
                handleCloseModal(); // modal kapat
              } catch (error) {
                console.error("Kaydetme hatası:", error);
              }
            }}
          >
            Evet
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showConfirm} onHide={handleConfirmNo} centered>
        <Modal.Header closeButton>
          <Modal.Title>⚠️ Admin Yetkisi Veriliyor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Bu rol için <b>Admin grubuna</b> ait bir yetki eklemek üzeresiniz.
          <br />
          Devam etmek istediğinize emin misiniz?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleConfirmNo}>
            Hayır
          </Button>
          <Button variant="danger" onClick={handleConfirmYes}>
            Evet, ekle
          </Button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
}

export default RoleManagementPage;
